
import api from './api';
import type { Driver, Paginated } from '../types/api';


export async function listDrivers() {
  const { data } = await api.get<Paginated<Driver> | Driver[]>('/drivers/');
  return Array.isArray(data) ? data : data.results;
}

export async function createDriver(payload: Partial<Driver>) {
  const { data } = await api.post<Driver>('/drivers/', payload);
  return data;
}

export async function updateDriver(id: number, payload: Partial<Driver>) {
  const { data } = await api.patch<Driver>(`/drivers/${id}/`, payload);
  return data;
}

export async function deleteDriver(id: number) {
  await api.delete(`/drivers/${id}/`);
}
